<template>
  <div class="floating-stack-tokens" :style="stackVars" aria-hidden="true"></div>
</template>

<script>
import { setFloatingConfig } from "@/services/floatingItems";

export default {
  name: "FloatingStack",
  props: {
    gapPx: {
      type: Number,
      default: 12,
    },
    inlinePx: {
      type: Number,
      default: 20,
    },
    bottomPx: {
      type: Number,
      default: 12,
    },
    baseZIndex: {
      type: Number,
      default: 1000,
    },
  },
  computed: {
    stackVars() {
      return {
        "--floating-stack-inline": `${this.inlinePx}px`,
        "--floating-stack-bottom": `calc(${this.bottomPx}px + env(safe-area-inset-bottom) + var(--floating-stack-bottom-extra, 0px))`,
      };
    },
  },
  watch: {
    gapPx: "syncConfig",
    baseZIndex: "syncConfig",
    inlinePx: "syncCssVars",
    bottomPx: "syncCssVars",
  },
  mounted() {
    this.syncCssVars();
    this.syncConfig();
  },
  methods: {
    syncCssVars() {
      const rootStyle = document.documentElement.style;
      rootStyle.setProperty("--floating-stack-inline", `${this.inlinePx}px`);
      rootStyle.setProperty(
        "--floating-stack-bottom",
        `calc(${this.bottomPx}px + env(safe-area-inset-bottom) + var(--floating-stack-bottom-extra, 0px))`
      );
    },
    syncConfig() {
      setFloatingConfig({
        gapPx: this.gapPx,
        baseZIndex: this.baseZIndex,
      });
    },
  },
};
</script>

<style scoped>
.floating-stack-tokens {
  width: 0;
  height: 0;
  pointer-events: none;
}
</style>
